import React from 'react';
import { FieldHex, FieldHexProps } from '@spotify-internal/anchor-ds';
import { FieldController, HookFormProps } from 'shared/FieldController';

export type ControlledFieldHexProps = HookFormProps &
  Omit<FieldHexProps, 'onChange'>;

export const ControlledFieldHex = (props: ControlledFieldHexProps) => (
  <FieldController<FieldHexProps, HTMLInputElement> as={FieldHex} {...props} />
);
